import React, { useRef } from 'react'
import { getImages } from '../Common/const'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Testimonials = () => {
    const sliderRef = useRef(null);

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
        <>
            <section className='testimonial-wrap'>
                <div className='container'>
                    <div className='main-title text-uppercase mb-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.2s">Testimonials</div>
                    <div className='testimonial-container wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">
                        <Slider ref={sliderRef} {...settings} className='testimonial-slider'>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Jonathan Hirsch</div>
                                            <div className='xxs-title text-white'>July 6, 2024</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Amazing collection and amazing customer service. These guys are very easy to work with and Mario was as good as it gets, I am so happy with the deal and I love the car. I have used the service department before and they did fantastic as well.</p>
                                </div>
                            </div>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Andrew Hernandez</div>
                                            <div className='xxs-title text-white'>Jan 12, 2023</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Absolutely love Mark Motors! In a difficult market, Gerardo searched high and low to find me a new car. Justin w/Mark Customs took my new, ordinary Escalade and turned it into my dream car. It’s gorgeous and exactly what I was hoping for! Their Customer Service is top notch and my family and I plan to be life-long customers.</p>
                                </div>
                            </div>
                            {/* 
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Jonathan Hirsch</div>
                                            <div className='xxs-title text-white'>July 6, 2024</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Amazing collection and amazing customer service. These guys are very easy to work with and Mario was as good as it gets, I am so happy with the deal and I love the car. I have used the service department before and they did fantastic as well.</p>
                                </div>
                            </div>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Andrew Hernandez</div>
                                            <div className='xxs-title text-white'>Jan 12, 2023</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Absolutely love Mark Motors! In a difficult market, Gerardo searched high and low to find me a new car. Justin w/Mark Customs took my new, ordinary Escalade and turned it into my dream car. It’s gorgeous and exactly what I was hoping for! Their Customer Service is top notch and my family and I plan to be life-long customers.</p>
                                </div>
                            </div> 
                            */}
                            {/* New Testimonials */}
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>L Portugal</div>
                                            <div className='xxs-title text-white'>5 months ago</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Excellent Service! Thank you Mario & Steven for making my Lamborghini transaction super fast! Highly recommend Mark Motors for their wide selection of exotic vehicles. Couldn’t be happier with my selection.</p>
                                </div>
                            </div>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Jessica Norcross</div>
                                            <div className='xxs-title text-white'>2 years ago</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Absolutely love Mark Motors! In a difficult market, Gerardo searched high and low to find me a new car. Justin w/Mark Customs took my new, ordinary Escalade and turned it into my dream car. It’s gorgeous and exactly what I was hoping for! Their Customer Service is top notch and my family and I plan to be life-long customers.</p>
                                </div>
                            </div>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Chet</div>
                                            <div className='xxs-title text-white'>a month ago</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Love Mark Motors - 5 star review for annual service, loaner drop off, pick up, service done right with a smile. Thank you Andres, Robert, service team for a hassle free experience.</p>
                                </div>
                            </div>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Drew Baker</div>
                                            <div className='xxs-title text-white'>6 months ago</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Cody at Mark Motors is the best in the business. We’ve done many many deals and they’ve always been more than smooth. Even though we’ve never met, I know I can trust MM and Cody with large transactions sight unseen. Don’t hesitate to do business with them!</p>
                                </div>
                            </div>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Z Abouhamzeh</div>
                                            <div className='xxs-title text-white'>a month ago</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Daniel Johnson is a true professional and I definitely recommend you work with him. Called him to get a buy bid on a Lamborghini Huracan and he was as honest and straightforward as one can be! Call and ask for Daniel Johnson!</p>
                                </div>
                            </div>
                            <div>
                                <div className='testimonial-box'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='sm-title font-1-8em text-theme'>Chris Allahyar</div>
                                            <div className='xxs-title text-white'>a year ago</div>
                                        </div>
                                        <div className='quote-icon'>
                                            <img src={getImages('quote.png')} alt='quote' />
                                        </div>
                                    </div>
                                    <p>Been working with Devin at Marks Motors for a while . Getting my trade in and buying my dream car was just absolutely great . Been buying a lot of cars and Never had such great experience with dealership or sales team . They guys are the best !! From the start to finish . Thank you , thank you</p>
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Testimonials